import * as Sentry from "@sentry/react";

if (process.env.NODE_ENV === "production") {
  console.log("Running sentry");

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_URL,
    integrations: [Sentry.browserTracingIntegration()],
    tracePropagationTargets: [/^\//, /^https?:\/\/.*/],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}